// Libraries
import React from 'react';
import PropTypes from 'prop-types';
// import _noop from 'lodash-es/noop';
// import _get from 'lodash-es/get';

import {
  BalanceWrapper,
  CompanyWrapper,
  HeaderCenterWrapper,
  HeaderContainer,
  HeaderDetailsContainer,
  HeaderWrapper,
} from './styles';
import UserWidget from './UserWidget';
import BalanceWidget from './BalanceWidget';
import CompanyDetails from './CompanyDetails';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';
import { isConnectedToStagging } from '../../../../helpers';

const HeaderNav = ({
  isLoggedIn,
  userDetails,
  selectedWorkspace,
  companyProfile,
  currentFlow,
}) => {
  return isLoggedIn ? (
    <HeaderWrapper isStagging={isConnectedToStagging()}>
      <HeaderCenterWrapper>
        <HeaderContainer>
          <CompanyWrapper>
            <CompanyDetails companyProfile={companyProfile} />
          </CompanyWrapper>
          <HeaderDetailsContainer>
            <BalanceWrapper>
              {selectedWorkspace && (
                <BalanceWidget
                  selectedWorkspace={selectedWorkspace}
                  currentFlow={currentFlow}
                />
              )}
            </BalanceWrapper>
            <UserWidget
              userDetails={userDetails}
              currentFlow={currentFlow}
              selectedWorkspace={selectedWorkspace}
            />
          </HeaderDetailsContainer>
        </HeaderContainer>
      </HeaderCenterWrapper>
    </HeaderWrapper>
  ) : null;
};

HeaderNav.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  isLoggedIn: PropTypes.bool,
  userDetails: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  companyProfile: PropTypes.objectOf(PropTypes.any),
};

HeaderNav.defaultProps = {
  isLoggedIn: false,
  userDetails: {},
  selectedWorkspace: {},
  companyProfile: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

export default HeaderNav;
